import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Alert, Row, Col, Label, Input, InputGroup, FormFeedback } from 'reactstrap';

import ParadigmaModal from "../../../../components/ParadigmaModal/ParadigmaModal.js";
import ParadigmaLabeledInput from "../../../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js"
import ParadigmaAsyncSeeker from "../../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"

import api from "../../../../api";
import functions from "../../../../functions";


class Modal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Codigo: "",
      Nombre: "",
      Domicilio: "",
      DomicilioEntrega: "",
      CodPostal: "",
      Telefono: "",
      NroDoc: "",
      Email: "",
      NuevaPassword: "",
      CantidadPedidos: 0,

      ImpuestoIIBB_id: null,
      Moneda_id: null,
      SituacionIVA_id: null,
      TipoDocumento_id: null,
      Localidad_id: null,
      CondicionDePagoDefecto_id: null,
      ListaDePrecios_id: null,
      TransportePredeterminado_id: null,

      TipoDocumentoElegido: "",

      postVariables: [
        'Nombre', 'Domicilio', 'DomicilioEntrega',
        'CodPostal', 'Telefono', 'NroDoc', 'Email',
        'TipoDocumento_id', 'Localidad_id', 'CondicionDePagoDefecto_id',
        'ListaDePrecios_id', 'TransportePredeterminado_id',
        'ImpuestoIIBB_id', 'SituacionIVA_id', 'Moneda_id',
        'NuevaPassword'
      ],
      errors: [],
    };
  }

  static propTypes = {
    onSubmit: PropTypes.func,
    id: PropTypes.func,
    action: PropTypes.oneOf(['CREATE', 'EDIT', 'DETAIL', 'DELETE']).isRequired,
  }

  resetForm() {
    this.setState({
      Codigo: "",
      Nombre: "",
      Domicilio: "",
      DomicilioEntrega: "",
      CodPostal: "",
      Telefono: "",
      NroDoc: "",
      Email: "",
      NuevaPassword: "",
      CantidadPedidos: 0,

      ImpuestoIIBB_id: null,
      Moneda_id: null,
      SituacionIVA_id: null,
      TipoDocumento_id: null,
      Localidad_id: null,
      CondicionDePagoDefecto_id: null,
      ListaDePrecios_id: null,
      TransportePredeterminado_id: null,

      TipoDocumentoElegido: "",

      errors: [],
    });
  }

  getData() {
    const { postVariables } = this.state;
    let data = {};
    postVariables.forEach(x => {
      data[x] = this.state[x];
    });
    return data;
  }

  setData(data) {
    if (data.success) {
      this.setState({
        Nombre: data.Nombre,
        Email: data.Email,
        Domicilio: data.Domicilio,
        DomicilioEntrega: data.DomicilioEntrega,
        CodPostal: data.CodPostal,
        Telefono: data.Telefono,
        NroDoc: data.NroDoc,
        Codigo: data.Codigo,
        CantidadPedidos: data.CantidadPedidos,

        TipoDocumento_id: data.TipoDocumento_id,
        Moneda_id: data.Moneda_id,
        ImpuestoIIBB_id: data.ImpuestoIIBB_id,
        SituacionIVA_id: data.SituacionIVA_id,
        Localidad_id: data.Localidad_id,
        CondicionDePagoDefecto_id: data.CondicionDePagoDefecto_id,
        ListaDePrecios_id: data.ListaDePrecios_id,
        TransportePredeterminado_id: data.TransportePredeterminado_id,

        TipoDocumentoElegido: "",
      });
    } else if (data.errors) {
      this.setErrors(data.errors);
    }
  }

  setErrors(errors) {
    this.setState({
      errors: errors,
    });
  }

  onChangeField(field, value) {
    this.setState(prevState => {
      let errors = prevState.errors;
      if (errors) errors[field] = null;
      prevState.errors = errors;
      prevState[field] = value;
      return prevState;
    });
  }

  getError(field) {
    let errors = this.state.errors;
    if (errors) {
      return errors[field];
    } else {
      return {};
    }
  }

  validate() {
    const email_regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w {2, 3})+$/;
    const { action } = this.props;
    const errors = {};
    let result = true;
    const pushError = (fieldName, code, detail, errors) => errors[fieldName] = [{ code, detail }];
    if (action == "CREATE") {
      if (this.state.Nombre != null && this.state.Nombre.trim().length == 0) pushError('Nombre', 'invalid', 'Nombre no puede ser vacio.', errors);
      if (this.state.Email != null && this.state.Email.trim().length == 0) pushError('Email', 'invalid', 'Correo Electronico no puede ser vacio.', errors);
      else if (email_regex.test(this.state.Email)) pushError('Email', 'invalid', 'Correo Electronico no respeta formato valido.', errors);
      if (this.state.Domicilio != null && this.state.Domicilio.trim().length == 0) pushError('Domicilio', 'invalid', 'Domicilio no puede ser vacio.', errors);
      if (this.state.CodPostal != null && this.state.CodPostal.trim().length == 0) pushError('CodPostal', 'invalid', 'Codigo Postal no puede ser vacio.', errors);
      if (this.state.Telefono != null && this.state.Telefono.trim().length == 0) pushError('Telefono', 'invalid', 'Telefono no puede ser vacio.', errors);
      if (this.state.NroDoc != null && this.state.NroDoc.trim().length == 0) pushError('NroDoc', 'invalid', 'Número de Documento no puede ser vacio.', errors);
      if (this.state.NuevaPassword != null && this.state.NuevaPassword.trim().length <= 7) pushError('NuevaPassword', 'invalid', 'Password no puede ser menor a 8 caracteres.', errors);

      if (this.state.SituacionIVA_id == null || this.state.SituacionIVA_id.trim().length == 0) pushError('SituacionIVA_id', 'invalid', 'Debe especificar la Situacion IVA sujeta al Cliente.', errors);
      if (this.state.TipoDocumento_id == null || this.state.TipoDocumento_id.trim().length == 0) pushError('TipoDocumento_id', 'invalid', 'Debe especificar el Tipo de Documento.', errors);
      else if (this.state.TipoDocumentoElegido == "D.N.I" && this.state.NroDoc != null && this.state.NroDoc.trim().length > 0 && functions.isValidDNI(this.state.NroDoc) == false) pushError('NroDoc', 'invalid', 'Formato incorrecto (7 u 8 números).', errors);
      else if (this.state.TipoDocumentoElegido == "CUIT" && this.state.NroDoc != null && this.state.NroDoc.trim().length > 0 && functions.isValidCUITCUIL(this.state.NroDoc) == false) pushError('NroDoc', 'invalid', 'CUIT no valido.', errors);
      if (this.state.CondicionDePagoDefecto_id == null || this.state.CondicionDePagoDefecto_id.trim().length == 0) pushError('CondicionDePagoDefecto_id', 'invalid', 'Debe elegir una Condicion de Pago por defecto.', errors);
      if (this.state.Moneda_id == null || this.state.Moneda_id.trim().length == 0) pushError('Moneda_id', 'invalid', 'Debe elegir una Moneda.', errors);
      if (this.state.ListaDePrecios_id == null || this.state.ListaDePrecios_id.trim().length == 0) pushError('ListaDePrecios_id', 'invalid', 'Debe especificar la Lista de Precios sujeta al Cliente.', errors);
      if (this.state.ListaDePrecios_id != null && this.state.ListaDePrecios_id == "000000") pushError('ListaDePrecios_id', 'invalid', 'La Lista de Precios elegida es incorrecta.', errors);
    } else if (action == "EDIT") {
      if (this.state.Nombre != null && this.state.Nombre.trim().length == 0) pushError('Nombre', 'invalid', 'Nombre no puede ser vacio.', errors);
      if (this.state.Email != null && this.state.Email.trim().length == 0) pushError('Email', 'invalid', 'Correo Electronico no puede ser vacio.', errors);
      else if (email_regex.test(this.state.Email)) pushError('Email', 'invalid', 'Correo Electronico no respeta formato valido.', errors);
      if (this.state.Domicilio != null && this.state.Domicilio.trim().length == 0) pushError('Domicilio', 'invalid', 'Domicilio no puede ser vacio.', errors);
      if (this.state.CodPostal != null && this.state.CodPostal.trim().length == 0) pushError('CodPostal', 'invalid', 'Codigo Postal no puede ser vacio.', errors);
      if (this.state.Telefono != null && this.state.Telefono.trim().length == 0) pushError('Telefono', 'invalid', 'Telefono no puede ser vacio.', errors);
      if (this.state.NroDoc != null && this.state.NroDoc.trim().length == 0) pushError('NroDoc', 'invalid', 'Nro Documento no puede ser vacio.', errors);
      if (this.state.NuevaPassword != "" && this.state.NuevaPassword.trim().length <= 7) pushError('NuevaPassword', 'invalid', 'Password no puede ser menor a 8 caracteres.', errors);

      if (this.state.SituacionIVA_id == null || this.state.SituacionIVA_id.trim().length == 0) pushError('SituacionIVA_id', 'invalid', 'Debe especificar la Situacion IVA sujeta al Cliente.', errors);
      if (this.state.TipoDocumento_id == null || this.state.TipoDocumento_id.trim().length == 0) pushError('TipoDocumento_id', 'invalid', 'Debe especificar el Tipo de Documento.', errors);
      else if (this.state.TipoDocumentoElegido == "D.N.I" && this.state.NroDoc != null && this.state.NroDoc.trim().length > 0 && functions.isValidDNI(this.state.NroDoc) == false) pushError('NroDoc', 'invalid', 'Formato incorrecto (7 u 8 números).', errors);
      else if (this.state.TipoDocumentoElegido == "CUIT" && this.state.NroDoc != null && this.state.NroDoc.trim().length > 0 && functions.isValidCUITCUIL(this.state.NroDoc) == false) pushError('NroDoc', 'invalid', 'CUIT no valido.', errors);
      if (this.state.CondicionDePagoDefecto_id == null || this.state.CondicionDePagoDefecto_id.trim().length == 0) pushError('CondicionDePagoDefecto_id', 'invalid', 'Debe elegir una Condicion de Pago por defecto.', errors);
      if (this.state.Moneda_id == null || this.state.Moneda_id.trim().length == 0) pushError('Moneda_id', 'invalid', 'Debe elegir una Moneda.', errors);
      if (this.state.ListaDePrecios_id == null || this.state.ListaDePrecios_id.trim().length == 0) pushError('ListaDePrecios_id', 'invalid', 'Debe especificar la Lista de Precios sujeta al Cliente.', errors);
      if (this.state.ListaDePrecios_id != null && this.state.ListaDePrecios_id == "000000") pushError('ListaDePrecios_id', 'invalid', 'La Lista de Precios elegida es incorrecta.', errors);
    } else if (action == "DELETE" && ((this.state.Codigo && this.state.Codigo.trim().length > 0) || this.state.CantidadPedidos > 0)) {
      result = false;
    }
    result = result && Object.keys(errors).length == 0;
    this.setErrors(errors);
    return result;
  }

  modalVars() {
    const { action } = this.props;
    if (action == "CREATE") {
      return {
        get: false,
        submitType: "POST",
        title: "Nuevo Cliente",
        buttonTitle: "Nuevo",
        danger: false,
        buttonIcon: "fa fa-plus fa-lg",
        successMessage: "El Cliente ha sido creado con éxito.",
        saveButton: true,
        saveButtonLabel: "Guardar",
        buttonClass: "",
        disabled: false,
      };
    } else if (action == "EDIT") {
      return {
        get: true,
        submitType: "PUT",
        title: "Editar Cliente",
        buttonTitle: "Editar",
        danger: false,
        buttonIcon: "fa fa-pencil fa-lg",
        successMessage: "El Cliente ha sido editado con éxito.",
        saveButton: true,
        saveButtonLabel: "Guardar",
        buttonClass: "",
        disabled: false,
        id: this.props.id,
      };
    } else if (action == "DETAIL") {
      return {
        get: true,
        submitType: null,
        title: "Cliente",
        buttonTitle: "Ver",
        danger: false,
        buttonIcon: "fa fa-search fa-lg",
        successMessage: "",
        saveButton: false,
        buttonClass: "",
        disabled: true,
        id: this.props.id,
      };
    } else if (action == "DELETE") {
      const { Codigo, CantidadPedidos } = this.state;
      const saveButton = (Codigo == null || Codigo == '') && CantidadPedidos == 0;
      return {
        get: true,
        submitType: "DELETE",
        title: "Eliminar Cliente",
        buttonTitle: "Eliminar",
        danger: true,
        buttonIcon: "fa fa-trash fa-lg",
        successMessage: "El Cliente ha sido eliminado con éxito.",
        saveButton: saveButton,
        saveButtonLabel: "Eliminar",
        buttonClass: "btn-danger",
        disabled: true,
        id: this.props.id,
      };
    }
  }

  render() {
    const { action } = this.props;
    let vars = this.modalVars();
    return (
      <ParadigmaModal
        getUrl={(vars.get ? api.gestion.ventas.clientes : null)}
        submitUrl={(vars.submitType ? api.gestion.ventas.clientes : null)}
        submitType={vars.submitType}
        id={vars.id}

        onGotData={(data) => this.setData(data)}
        onGotErrors={(errors) => this.setErrors(errors)}
        onSubmit={(e) => this.props.onSubmit(e)}
        onClose={() => this.resetForm()}
        onPreSubmit={() => this.getData()}
        onValidation={() => this.validate()}

        title={vars.title}

        danger={vars.danger}
        buttonClass={vars.buttonClass}

        successMessage={vars.successMessage}
        missingIdMessage={"Debe seleccionar una fila."}

        saveButtonLabel={vars.saveButtonLabel}
        buttonTitle={vars.buttonTitle}
        buttonIcon={vars.buttonIcon}
        saveButton={vars.saveButton}
        closeButton={true}

        className="modal-lg"
      >
        <ParadigmaLabeledInput
          disabled={vars.disabled}
          md={[3, 9]}
          label={"Nombre"}
          value={this.state.Nombre}
          onChange={(e) => this.onChangeField('Nombre', e.target.value)}
          error={() => this.getError('Nombre')}
        />
        <ParadigmaLabeledInput
          disabled={vars.disabled}
          md={[3, 9]}
          label={"Correo Electronico"}
          value={this.state.Email}
          onChange={(e) => this.onChangeField('Email', e.target.value)}
          error={() => this.getError('Email')}
        />

        <Row>
          <Col xs={6}>
            <ParadigmaLabeledInput
              md={[6, 6]}
              label={"Documento"}
              inputComponent={
                <ParadigmaAsyncSeeker
                  disabled={vars.disabled}
                  url={api.gestion.generales.tiposdoc}
                  value={this.state.TipoDocumento_id}
                  valueField="Codigo"
                  displayField="Nombre"
                  parameters={{ paginationEnabled: "False", filters: ["DeBaja=False"], sort: ["Nombre"], fields:['Codigo', 'Nombre'] }}
                  onChange={(data) => {
                    this.onChangeField('TipoDocumento_id', (data ? data.Codigo : null));
                    this.onChangeField('TipoDocumentoElegido', (data ? data.Nombre : null));
                  }}
                />
              }
              error={() => this.getError('TipoDocumento_id')}
            />
          </Col>
          <Col>
            <ParadigmaLabeledInput
              disabled={vars.disabled}
              md={[3, 9]}
              label={"Número"}
              value={this.state.NroDoc}
              onChange={(e) => this.onChangeField('NroDoc', e.target.value)}
              error={() => this.getError('NroDoc')}
            />
          </Col>
        </Row>

        <Row>
          <Col xs={9}>
            <ParadigmaLabeledInput
              md={[4, 8]}
              label={"Localidad"}
              inputComponent={
                <ParadigmaAsyncSeeker
                  disabled={vars.disabled}
                  url={api.gestion.generales.localidades}
                  value={this.state.Localidad_id}
                  valueField="Codigo"
                  displayField="fullName"
                  parameters={{ paginationEnabled: "False", filters: ["DeBaja=False"], sort: ["Provincia", "Nombre"], fields:['Codigo', 'fullName', 'CodigoPostal'] }}
                  onChange={(data) => {
                    this.onChangeField('Localidad_id', (data ? data.Codigo : null));
                    this.onChangeField('CodPostal', (data ? data.CodigoPostal : this.state.CodPostal));
                  }}
                />
              }
              error={() => this.getError('Localidad_id')}
            />
          </Col>
          <Col>
            <ParadigmaLabeledInput
              disabled={vars.disabled}
              md={[3, 9]}
              label={"C.P."}
              value={this.state.CodPostal}
              onChange={(e) => this.onChangeField('CodPostal', e.target.value)}
              error={() => this.getError('CodPostal')}
            />
          </Col>
        </Row>


        <ParadigmaLabeledInput
          disabled={vars.disabled}
          md={[3, 9]}
          label={"Domicilio"}
          value={this.state.Domicilio}
          onChange={(e) => this.onChangeField('Domicilio', e.target.value)}
          error={() => this.getError('Domicilio')}
        />
        <ParadigmaLabeledInput
          disabled={vars.disabled}
          md={[3, 9]}
          label={"Domicilio de Entrega"}
          value={this.state.DomicilioEntrega}
          onChange={(e) => this.onChangeField('DomicilioEntrega', e.target.value)}
          error={() => this.getError('DomicilioEntrega')}
        />
        <ParadigmaLabeledInput
          disabled={vars.disabled}
          md={[3, 9]}
          label={"Telefono"}
          value={this.state.Telefono}
          onChange={(e) => this.onChangeField('Telefono', e.target.value)}
          error={() => this.getError('Telefono')}
        />
        <ParadigmaLabeledInput
          md={[3, 9]}
          label={"Moneda Asignada"}
          inputComponent={
            <ParadigmaAsyncSeeker
              disabled={vars.disabled}
              url={api.gestion.generales.monedas}
              value={this.state.Moneda_id}
              displayField="Nombre"
              valueField="Codigo"
              parameters={{ paginationEnabled: "False", filters: ["DeBaja=False"], sort: ["Nombre"] }}
              onChange={(data) => this.onChangeField('Moneda_id', (data ? data.Codigo : null))}
            />
          }
          error={() => this.getError('Moneda_id')}
        />
        <ParadigmaLabeledInput
          md={[3, 9]}
          label={"Lista de Precio Asignada"}
          inputComponent={
            <ParadigmaAsyncSeeker
              disabled={vars.disabled}
              url={api.gestion.precios.listas}
              value={this.state.ListaDePrecios_id}
              displayField="Nombre"
              valueField="Codigo"
              parameters={{ paginationEnabled: "False", filters: ["DeBaja=False", "Codigo[not]=000000"], sort: ["Nombre"], fields:['Codigo', 'Nombre'] }}
              onChange={(data) => this.onChangeField('ListaDePrecios_id', (data ? data.Codigo : null))}
            />
          }
          error={() => this.getError('ListaDePrecios_id')}
        />
        <ParadigmaLabeledInput
          md={[3, 9]}
          label={"Condicion de Pago Defecto"}
          inputComponent={
            <ParadigmaAsyncSeeker
              disabled={vars.disabled}
              url={api.gestion.ventas.condicionesdepago}
              value={this.state.CondicionDePagoDefecto_id}
              displayField="Nombre"
              valueField="Codigo"
              parameters={{ paginationEnabled: "False", filters: ["DeBaja=False"], sort: ["Nombre"], fields:['Codigo', 'Nombre'] }}
              onChange={(data) => this.onChangeField('CondicionDePagoDefecto_id', (data ? data.Codigo : null))}
            />
          }
          error={() => this.getError('CondicionDePagoDefecto_id')}
        />
        <ParadigmaLabeledInput
          md={[3, 9]}
          label={"Situacion de IVA"}
          inputComponent={
            <ParadigmaAsyncSeeker
              disabled={vars.disabled}
              url={api.gestion.generales.situacioniva}
              value={this.state.SituacionIVA_id}
              displayField="Nombre"
              valueField="Codigo"
              parameters={{ paginationEnabled: "False", sort: ["Nombre"], filters: ["DeBaja=False"], fields:['Codigo', 'Nombre'] }}
              onChange={(data) => this.onChangeField('SituacionIVA_id', (data ? data.Codigo : null))}
            />
          }
          error={() => this.getError('SituacionIVA_id')}
        />
        <ParadigmaLabeledInput
          md={[3, 9]}
          label={"Impuesto IIBB"}
          inputComponent={
            <ParadigmaAsyncSeeker
              disabled={vars.disabled}
              url={api.gestion.generales.impuestos}
              value={this.state.ImpuestoIIBB_id}
              displayField="Nombre"
              valueField="Codigo"
              parameters={{ paginationEnabled: "False", filters: ["DeBaja=False"], sort: ["Nombre"], fields:['Codigo', 'Nombre']}}
              onChange={(data) => this.onChangeField('ImpuestoIIBB_id', (data ? data.Codigo : null))}
            />
          }
          error={() => this.getError('ImpuestoIIBB_id')}
        />
        <ParadigmaLabeledInput
          md={[3, 9]}
          label={"Transporte Pred."}
          inputComponent={
            <ParadigmaAsyncSeeker
              disabled={vars.disabled}
              url={api.gestion.generales.transportes}
              value={this.state.TransportePredeterminado_id}
              displayField="Nombre"
              valueField="Codigo"
              parameters={{ paginationEnabled: "False", filters: ["DeBaja=False"], sort: ["Nombre"], fields:['Codigo', 'Nombre'] }}
              onChange={(data) => this.onChangeField('TransportePredeterminado_id', (data ? data.Codigo : null))}
            />
          }
          error={() => this.getError('TransportePredeterminado_id')}
        />
        {
          (action == "CREATE" || action == "EDIT") &&
          <React.Fragment>
            <hr className="border m-1" />
            <ParadigmaLabeledInput
              disabled={vars.disabled}
              md={[3, 9]}
              label={action == "CREATE" ? "Contraseña" : "Nueva Contraseña"}
              value={this.state.NuevaPassword}
              onChange={(e) => this.onChangeField('NuevaPassword', e.target.value)}
              error={() => this.getError('NuevaPassword')}
            />
            <small>Rellene el campo solo si desea establecer una contraseña nueva</small>
          </React.Fragment>
        }
        {
          action == "DELETE" &&
          this.state.Codigo && this.state.Codigo.trim().length > 0 &&
          <React.Fragment>
            <hr className="border m-1" />
            <Alert color="danger">Imposible eliminar cliente existente en SIGE (Codigo de Cliente: {this.state.Codigo}).</Alert>
          </React.Fragment>
        }
        {
          action == "DELETE" &&
          this.state.CantidadPedidos > 0 &&
          <React.Fragment>
            <hr className="border m-1" />
            <Alert color="danger">Imposible eliminar cliente existente con pedidos (Cantidad de Pedidos: {this.state.CantidadPedidos}).</Alert>
          </React.Fragment>
        }
      </ParadigmaModal>
    );
  }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/views/Gestion/Ventas/Clientes/Modal.js